/**
Project: Phone Connect (c)
Title: i18n
Description: Internationalization settings
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

/*
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
*/

import common_en from "./app/core/translations/en/common.json";
import signin_en from "./app/core/translations/en/signin.json";
import error_en from "./app/core/translations/en/error.json";
import suc_common_en from "./app/pages/common/translations/en/common.json";
import suc_home_en from "./app/pages/common/translations/en/home.json";
import suc_numbers_en from "./app/pages/numbers/translations/en/number.json";
import suc_navbar_en from "./app/pages/common/translations/en/navbar.json";
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        common: common_en,
        signin: signin_en,
        error: error_en,
        suc_common: suc_common_en,
        suc_home:suc_home_en,
        suc_numbers:suc_numbers_en,
        suc_navbar:suc_navbar_en
      },
      /*
      de: {
        common: common_de,
      },
      */
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
